import { SvgIconProps } from "@mui/material";

import En from "../../assets/icons/En.svg";
import Nl from "../../assets/icons/Nl.svg";
import De from "../../assets/icons/De.svg";
import Fr from "../../assets/icons/Fr.svg";
import Rs from "../../assets/icons/Rs.svg";
import Pt from "../../assets/icons/Pt.svg";

type LocaleIconProps = { name: string } & SvgIconProps;

type LocaleIconTypes = {
  [name: string]: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
};

const iconTypes: LocaleIconTypes = {
  en: En,
  nl: Nl,
  sr: Rs,
  de: De,
  fr: Fr,
  pt: Pt,
};

const LocaleIcon: React.FC<LocaleIconProps> = ({
  name,
  ...props
}: LocaleIconProps) => {
  const Icon = iconTypes[name];
  return <Icon {...props} />;
};

export default LocaleIcon;
